import { render, staticRenderFns } from "./ModalFormularioMontosComisiones.vue?vue&type=template&id=72bf92d1&scoped=true"
import script from "./ModalFormularioMontosComisiones.vue?vue&type=script&lang=js"
export * from "./ModalFormularioMontosComisiones.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioMontosComisiones.vue?vue&type=style&index=0&id=72bf92d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf92d1",
  null
  
)

export default component.exports